import React, { useState } from "react";
import "./app-wide.css"
import "./contactus.css"
import { MdShortText } from "react-icons/md";
import { LuText } from "react-icons/lu";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaSquareInstagram } from "react-icons/fa6";






const ContactUs = () =>{

    const circles = [
        { top: '20px', left: '30px', size: '40px', color: '#163150' },
        { top: '150px', left: '100px', size: '80px', color: '#3A6EA5' },
        { top: '250px', left: '200px', size: '60px', color: '#5D9CEC' },
        { top: '575px', left: '375px', size: '150px', color: '#5D9CEC' }
      ];


    const [form, setForm] = useState({
        name: "",
        email: "",
        message: ""
      });
    
      const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
      };
    
      const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form submitted:", form);
        // You can integrate with an API or email service here
        setForm({ name: "", email: "", message: "" });
      };

    
    return(
        <div className="contact-us-section">
            <div className="contact-us-inner">
                <div className="contact-form-container">
                    <LuText size={20} className="contact-us-top-logo" />
                    <h1 className="contact-us-title">Contact Us</h1>
                    <p className="contact-us-sub-title">
                        Please feel free to contact us and we will get back to you as soon as we can.
                    </p>

                    <div className="contact-form-section">
                        <form className="contact-form" onSubmit={handleSubmit}>
                        <input
                            className="input-field"
                            type="text"
                            name="name"
                            placeholder="Name"
                            value={form.name}
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            className="input-field"
                            placeholder="Email"
                            value={form.email}
                            onChange={handleChange}
                            required
                        />
                        <textarea
                            name="message"
                            className="input-field"
                            placeholder="Message"
                            value={form.message}
                            onChange={handleChange}
                            rows={6}
                            required
                        ></textarea>
                        <button type="submit">Send</button>
                        </form>
                    </div>

                </div>
                <div className="contact-us-left-container">
                    {/*<div className="contact-us-left-logo-container">
                        <img src="stockarchiveslogo2.png"/>
                    </div>
                    <div className="contact-us-left-sub-title-container">
                        <h1>Stock Archives</h1>
                    </div>
                    <div className="contact-us-left-sub-title-container"> 
                        <div>
                            <FaSquareXTwitter/>
                        </div>
                        <div>
                            <FaSquareInstagram/>
                        </div>
                    </div>*/}
                        {circles.map((c, i) => (
                            <div
                                key={i}
                                className="circle"
                                style={{
                                 '--top': c.top,
                                    '--left': c.left,
                                    '--size': c.size,
                                    backgroundColor: c.color
                            }}
                            />
                            ))}
                </div>
            </div>
        </div>
    );
}

export default ContactUs;